module.exports = __webpack_public_path__ + "static/media/43.c3daac71.png";